import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getLensBrandsURL, getRXLensTypesURL,getRXLensIndexesURL, getRXLensSphURL,getRXLensCylURL, getRXProductsURL, getProductByCodeURL, getMatrixQuantityURL, getRXOrderPreviewURL, getSubmitRXOrderURL, getRXLensDesignTypesURL, getRXLensMaterialTypesURL, getRXCoatingURL, getRXExtraServicesURL, getOrderURL, getChangeOrderStateRL, getOrderPaymentURL} from '../api';
import moment from 'jalali-moment'
import { GroupBy } from "../helpers/mmg";
import { InputOutlined } from "@mui/icons-material";
import { setOrderLoadingFalse } from "./orders.slice";

export const zeroPad = (num, places) => String(num).padStart(places, '0');

// initial state
export const initialState = {
  selectedRXOrderId : null,
  consumer : null,
  customerPortalUserId : '' ,
  customerPortalCreatorId : '',
  storeName : null,
  loading: false,
  boxMessage : '',
  boxType : 0,//1 Error , 2 Success, 3 Info
  error: false,
  errorMessage : '',
  successMessage : '',
  currentPageIndex : 0,
  hasMore : true,

  lensbrands: [],
  selectedLensBrandId : 0,
  lensTypes : [],
  selectedLensTypeId : 0,

  lensDesignTypes : [],
  selectedLensDesignTypeId : 0,

  lensIndexes : [],
  selectedLensIndexId : 0,

  lensMaterialTypes : [],
  selectedLensMaterialTypeId : 0,

  products : [],

  coatings : [],
  selectedCoatingId : null,

  corridors : [{ Value : "auto", Name : "auto"}, { Value : "14mm", Name : "14mm"}, { Value : "16mm", Name : "16mm"}, { Value : "18mm", Name : "18mm"}],
  selectedCorridor : '',

  description : '',
  dateMustDelivered : '',
  netPrice : 0,
  //emergencyLevels : [{ Value : 1, Name : "عادی"}, { Value : 2, Name : "فوری"}],
  emergencyLevels : [{ Value : 1, Name : "عادی"}],
  //چشم ها
  Sphs : [],
  Cyls : [],
  ADDs : [],
  DIAs : [],
  DCs : [],
  Axiss : [],
  Positions : [{ Value : "to nasal", Name : "to nasal"}, { Value : "to temple", Name : "to temple"}],
  Prisms : [],
  BaseOfPrisms : [{ Value : "UP", Name : "UP"}, { Value : "DOWN", Name : "DOWN"}, { Value : "IN", Name : "IN"}, { Value : "OUT", Name : "OUT"}, { Value : "IN/UP", Name : "IN/UP"}, { Value : "IN/DOWN", Name : "IN/DOWN"}, { Value : "OUT/UP", Name : "OUT/UP"}, { Value : "OUT/DOWN", Name : "OUT/DOWN"}],
  //چپ
  LSPHSign : "false",
  LSPH : null,
  LCYLSign : "false",
  LCYL : null,
  LAXIS : null,
  LADD : null,
  LDIA : null,
  LDC : null,
  LPosition : null,
  LPrism : null,
  LBaseOfPrism : null,
  //راست
  RSPHSign : "false",
  RSPH : null,
  RCYLSign : "false",
  RCYL : null,
  RAXIS : null,
  RADD : null,
  RDIA : null,
  RDC : null,
  RPosition : null,
  RPrism : null,
  RBaseOfPrism : null,

  //ابعاد فریم
  HBOX : null,
  VBOX : null,
  DBL : null,
  ED : null,
  PANTO : null,
  FFA : null,
  BVD : null,
  BASEs : [],
  selectedBase : null,
  IPDR : null,
  IPDL : null,
  FITTINGL : null,
  FITTINGR : null,
  FrameTypes : [{ Value : "1", Name : "FULL"}, { Value : "2", Name : "RIMLESS"}, { Value : "3", Name : "SEMI-RIMLESS"}],
  selectedFrameType : null,
  colors : [{ Value : "Brown", Name : "Brown"}, { Value : "Grey", Name : "Grey"}, { Value : "Green", Name : "Green"}, { Value : "Blue", Name : "Blue"}, { Value : "Yellow", Name : "Yellow"}, { Value : "Purple", Name : "Purple"}, { Value : "Pink", Name : "Pink"}, { Value : "Black", Name : "Black"}, { Value : "Orange", Name : "Orange"}, { Value : "Red", Name : "Red"}],
  selectedColor : null,
  coloringTypes : [{ Value : "1", Name : "FULL"}, { Value : "2", Name : "GRADUAL"}, { Value : "3", Name : "SAME AS SAMPLE"}],
  selectedColoringType : null,
  colorRate : null,
  colorRateTop : null,
  colorRateBottom : null,

  ExtraServices : [],
  selectedExtraServices : [],
  service : '',

  oldLens : null,

  selectedProductId : 0,
  selectedProductCode : '',
  selectedProductTitle : '',
  selectedQuantity : '',
  selectedFee : 0,

  items : [],
  previewItems : [],
  previewItemsDialog : false,
  readOnly : false,
  
  searchKey : '',
  selectedRXStateDescription : '',
  orderState : '',
  emergencyLevel :  1,

  payTypeId : 1
};

// our slice
const rxOrderSlice = createSlice({
  name: "storder",
  initialState,
  reducers: {
    setPostRefId: (state, { payload }) =>{
      state.loading = false;
      state.postRefId = payload;
    },
    initialRXOrder : (state) => {

      state.Sphs = [];
      for (var i = 0.00; i <= 32.00; i += 0.25)
      {
        state.Sphs.push(i.toFixed(2));
      }

      state.Cyls = [];
      for (var i = 0.00; i <= 12.00; i += 0.25)
      {
        state.Cyls.push(i.toFixed(2));
      }

      state.Axiss = [];
      for (var i = 1; i <= 180; i += 1)
      {
        state.Axiss.push(i.toString());
      }

      state.ADDs = [];
      for (var i = 0.5; i <= 5.00; i += 0.25)
      {
        state.ADDs.push(i.toFixed(2));
      }

      state.DIAs = [];
      for (var i = 40; i <= 80; i += 1){
        state.DIAs.push(i.toFixed(0));
      }

      state.DCs = [];
      for (var i = 1; i <= 10; i += 1){
        state.DCs.push(i.toString() + "mm");
      }

      state.Prisms = [];
      for (var i = 0.25; i <= 15; i += 0.25){
        state.Prisms.push(i.toFixed(2));
      }
      
      state.BASEs = [];
      state.BASEs.push('STA');
      state.selectedBase = 'STA';
      for (var i = 0; i <= 12; i += 0.5){
        state.BASEs.push("BASE " + i.toFixed(1));
      }

    },
    updateRXOrderADDValues : (state, { payload }) =>{

      state.RADD = null;
      state.LADD = null;
      var selectedLensBrandTitle = "";
      var selectedLensTypeTitle = "";
      var selectedLensDesignTypeTitle = "";

      if(state.lensbrands.length > 0 && state.selectedLensBrandId > 0){
        if(state.lensbrands.find(r => r.Value === state.selectedLensBrandId.toString())){
          selectedLensBrandTitle = state.lensbrands.find(r => r.Value === state.selectedLensBrandId.toString()).Name;
        }
      }

      if(state.lensTypes.length > 0 && state.selectedLensTypeId > 0){
        if(state.lensTypes.find(r => r.Value === state.selectedLensTypeId.toString())){
          selectedLensTypeTitle = state.lensTypes.find(r => r.Value === state.selectedLensTypeId.toString()).Name;
        }
      }

      if(state.lensDesignTypes.length > 0 && state.selectedLensDesignTypeId > 0){
        if(state.lensDesignTypes.find(r => r.Value === state.selectedLensDesignTypeId.toString())){
          selectedLensDesignTypeTitle = state.lensDesignTypes.find(r => r.Value === state.selectedLensDesignTypeId.toString()).Name;
        }
      }

      console.log(selectedLensBrandTitle);
      console.log(selectedLensTypeTitle);
      console.log(selectedLensDesignTypeTitle);
      state.ADDs = [];
      if (selectedLensTypeTitle.toLowerCase() === "lifestyle" && selectedLensBrandTitle.toLowerCase() === "optex" && selectedLensDesignTypeTitle.toLowerCase() === "anti-fatigue") {
          //SetADDValues(1);
          for (var i = 0.5; i <= 0.75; i += 0.25)
          {
            state.ADDs.push(i.toFixed(2));
          }
      }
      else if (selectedLensBrandTitle.toLowerCase().toLowerCase() === "optex" && selectedLensDesignTypeTitle.toLowerCase() != "proto"){
          //SetADDValues(2);
          for (var i = 0.50; i <= 5; i += 0.25)
          {
            state.ADDs.push(i.toFixed(2));
          }
      }
      else if (selectedLensBrandTitle.toLowerCase().toLowerCase() === "indo" && selectedLensTypeTitle.toLowerCase() === "lifestyle" && selectedLensDesignTypeTitle.toLowerCase() === "pottencia"){
        //SetADDValues(2);
        
          state.ADDs.push((0.47).toFixed(2));
          state.ADDs.push((0.60).toFixed(2));
          state.ADDs.push((0.80).toFixed(2));
          state.ADDs.push((1.10).toFixed(2));
      }
      else {
          //SetADDValues(0);
          for (var i = 0.50; i <= 3.75; i += 0.25) {
          {
            state.ADDs.push(i.toFixed(2));
          }
      }
      }
    },
    setRXOrderLoading: (state) => {
      state.loading = true;
    },
    setRXOrderLoadingFalse: (state) => {
      state.loading = false;
    },
    setRXOrderReadonly: (state) => {
      state.readOnly = true;
    },
    setRXOrderWrite: (state) => {
      state.readOnly = false;
    },
    setCustomerPortalUserId: (state, { payload }) =>{
      state.customerPortalUserId = payload;
    },
    clearCustomerPortalUserId: (state, { payload }) =>{
      state.customerPortalUserId = '';
    },
    setRXOrderSearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setRXOrderStateDescription : (state, { payload }) =>{
      state.selectedRXStateDescription = payload;
    },
    setSelectedRXOrderId: (state, { payload }) => {
      state.loading = false;
      console.log("selectedRXOrderId");
      state.fetchPermission = false;// یعنی وارد یک فاکتور شدیم و دیگه مجدد لود نکنه اطلاعات رو
      state.selectedRXOrderId = payload;
    },
    setSelectedRXOrder: (state, { payload }) => {
      state.loading = false;
      state.selectedRXOrder = payload;
      state.selectedRXOrderId = payload.ID;
      state.fetchPermission = false;
    },
    setRXOrderResultBox: (state, { payload }) => {

      console.log("setRXOrderResultBox");
      console.log(payload);
      state.boxMessage = payload.message;
      state.boxType = payload.type;//1 Error , 2 Success, 3 Info
    },
    resetRXOrderResultBox: (state, { payload }) => {
      state.boxMessage = ''
      state.boxType = 0;//1 Error , 2 Success, 3 Info
    },
    setRXOrderPayType : (state, { payload }) => {
      state.payTypeId = payload;
    },
    //#region چشم راست
    setRXOrderSelectedRSPHSign: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RSPHSign = payload;
      state.loading = false;
    },
    setRXOrderSelectedRSPH: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === "" || payload === undefined || payload === null){
        state.RSPH = null;
      }else{
        state.RSPH = payload;
      } 
      state.loading = false;
    },
    setRXOrderSelectedRCYLSign: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RCYLSign = payload;
      state.loading = false;
    },    
    setRXOrderSelectedRCYL: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === "" || payload === undefined || payload === null){
        state.RCYL = null;
        state.RAXIS = null;
      }else{

        state.RCYL = payload;
        if(payload.toString() === "0.00"){
          state.RAXIS = null;
        }
      } 
      state.loading = false;
    },
    setRXOrderSelectedRAxis: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === "" || payload === undefined || payload === null){
        state.RAXIS = null;
      }else{
        state.RAXIS = payload;
      }    
      state.loading = false;
    },
    setRXOrderSelectedRAdd: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RADD = payload;
      state.loading = false;
    },
    setRXOrderSelectedRDia: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RDIA = payload;

      state.HBOX = null;
      state.VBOX = null;
      state.DBL = null;
      state.ED = null;

      state.loading = false;
    },
    setRXOrderSelectedRDC: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RPosition = null;
      state.RDC = payload;
      state.loading = false;
    },
    setRXOrderSelectedRPosition: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RPosition = payload;
      state.loading = false;
    },
    setRXOrderSelectedRPrism: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RBaseOfPrism = null;
      state.RPrism = payload;
      state.loading = false;
    },
    setRXOrderSelectedRBaseOfPrism: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.RBaseOfPrism = payload;
      state.loading = false;
    },
    //#endregion
    //#region چشم چپ
    setRXOrderSelectedLSPHSign: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LSPHSign = payload;
      state.loading = false;
    },
    setRXOrderSelectedLSPH: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LSPH = payload;
      //if(payload === null){
      //  state.LCYL = null;
        //state.
      //}
      state.loading = false;
    },
    setRXOrderSelectedLCYLSign: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LCYLSign = payload;
      state.loading = false;
    },    
    setRXOrderSelectedLCYL: (state, { payload }) => {

      if(payload === "" || payload === undefined || payload === null){
        state.LCYL = null;
        state.LAXIS = null;
      }else{
        state.LCYL = payload;
        if(payload.toString() === "0.00"){
          state.LAXIS = null;
        }
      } 

    },
    setRXOrderSelectedLAxis: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === "" || payload === undefined || payload === null){
        state.LAXIS = null;
      }else{
        state.LAXIS = payload;
      }    
      state.loading = false;
    },
    setRXOrderSelectedLAdd: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === "" || payload === undefined || payload === null){
        state.LADD = null;
      }else{
        state.LADD = payload;
      }  
      state.loading = false;
    },
    setRXOrderSelectedLDia: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === "" || payload === undefined || payload === null){
        state.LDIA = null;
      }else{
        state.LDIA = payload;
      }  
      state.loading = false;
    },
    setRXOrderSelectedLDC: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LPosition = null;
      state.LDC = payload;
      state.loading = false;
    },
    setRXOrderSelectedLPosition: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LPosition = payload;
      state.loading = false;
    },
    setRXOrderSelectedLPrism: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LBaseOfPrism = null;
      state.LPrism = payload;
      state.loading = false;
    },
    setRXOrderSelectedLBaseOfPrism: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.LBaseOfPrism = payload;
      state.loading = false;
    },
    //#endregion
    
    copyLeftItemsToRight: (state, { payload }) => {

      state.RSPHSign= state.LSPHSign;
      state.RSPH= state.LSPH;
      state.RCYLSign= state.LCYLSign;
      state.RCYL= state.LCYL;
      state.RAXIS= state.LAXIS;
      state.RADD= state.LADD;
      state.RDIA= state.LDIA;
      state.RDC= state.LDC;
      state.RPosition= state.LPosition;
      state.RPrism= state.LPrism;
      state.RBaseOfPrism= state.LBaseOfPrism;

    },
    copyRightItemsToLeft: (state, { payload }) => {

      state.LSPHSign= state.RSPHSign;
      state.LSPH= state.RSPH;
      state.LCYLSign= state.RCYLSign;
      state.LCYL= state.RCYL;
      state.LAXIS= state.RAXIS;
      state.LADD= state.RADD;
      state.LDIA= state.RDIA;
      state.LDC= state.RDC;
      state.LPosition= state.RPosition;
      state.LPrism= state.RPrism;
      state.LBaseOfPrism= state.RBaseOfPrism;

    },
    //#region محصول
    setRXOrderSelectedCorridor: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedCorridor = payload;
      state.loading = false;
    },
    setRXOrderCoatings: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.coatings = payload;

      console.log("Going to Make selected Coating");
      if(state.coatings !== undefined && state.coatings !== null && state.coatings.length > 0){
        console.log("Make selected Coating");
        console.log(state.coatings);
        console.log(state.coatings.find(r => r.IsDefault == true));
        if(state.coatings.find(r => r.IsDefault == true) !== undefined){
          state.selectedCoatingId = state.coatings.find(r => r.IsDefault == true).Value;
        }
        console.log(state.selectedCoatingId);
      }

      state.loading = false;
    },  
    setRXOrderSelectedCoating: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedCoatingId = payload;
      state.loading = false;
    },
    setRXOrderLensBrands: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensbrands = payload;
      state.loading = false;
    },
    setRXOrderSelectedLensBrand: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensBrandId = payload;
      state.selectedLensTypeId = 0;
      state.selectedLensDesignTypeId = 0;
      state.selectedLensIndexId = 0;
      state.selectedLensMaterialTypeId = 0;
      state.selectedProductId = 0;
      state.lensTypes = [];
      state.lensDesignTypes = [];
      state.lensIndexes = [];
      state.lensMaterialTypes = [];
      state.products = [];
      state.loading = false;
    },
    setRXOrderLensTypes: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);

      state.lensTypes = payload;
      state.selectedLensTypeId = 0;
      state.loading = false;
      state.selectedCorridor = '';

    },
    setRXOrderSelectedLensType: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedCorridor = '';

      state.selectedLensTypeId = payload;
      state.selectedLensDesignTypeId = 0;
      state.selectedLensIndexId = 0;
      state.selectedLensMaterialTypeId = 0;
      state.selectedProductId = 0;

      state.RADD = null;
      state.LADD = null;

      state.lensDesignTypes = [];
      state.lensIndexes = [];
      state.lensMaterialTypes = [];
      state.products = [];

      state.loading = false;
    },
    setRXOrderLensDesignTypes: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensDesignTypes = payload;
      state.selectedLensDesignTypeId = 0;
      state.loading = false;
    },
    setRXOrderSelectedLensDesignType: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensDesignTypeId = payload;
     
      state.selectedLensIndexId = 0;
      state.selectedLensMaterialTypeId = 0;
      state.selectedProductId = 0;

      state.lensIndexes = [];
      state.lensMaterialTypes = [];
      state.products = [];

      state.loading = false;
    },
    setRXOrderLensIndexes: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensIndexes = payload;
      state.selectedLensIndexId = 0;
      state.loading = false;
    },
    setRXOrderSelectedLensIndex: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensIndexId = payload;

      state.selectedLensMaterialTypeId = 0;
      state.selectedProductId = 0;

      state.lensMaterialTypes = [];
      state.products = [];

      state.loading = false;
    },
    setRXOrderLensMaterialTypes: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensMaterialTypes = payload;
      state.selectedLensMaterialTypeId = 0;
      state.loading = false;
    },
    setRXOrderSelectedLensMaterialType: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensMaterialTypeId = payload;


      state.selectedProductId = 0;

      state.products = [];

      state.loading = false;
    },
    setRXOrderProducts: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.products = payload;

      if(state.products !== undefined && state.products !== null && state.products.length === 1){

        state.selectedProductId = payload[0].Value;
        state.selectedProductCode = payload[0].Code;
        state.selectedProductTitle = payload[0].Name;
        state.selectedFee = payload[0].Fee;
        state.selectedQuantity = '1';
      }else{
        state.selectedProductId = 0;
        state.selectedProductCode = '';
        state.selectedProductTitle = '';
        state.selectedQuantity = '';
        state.selectedFee = 0;
      }

      state.loading = false;
    },
    setRXOrderSelectedProduct: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === null){
        state.selectedProductId = 0;
        state.selectedProductCode = '';
        state.selectedProductTitle = '';
        state.selectedQuantity = '';
        state.selectedFee = 0;
      }else{
        state.selectedProductId = payload.selectedProductId;
        state.selectedProductCode = payload.selectedProductCode;
        state.selectedProductTitle = payload.selectedProductTitle;
        state.selectedFee = payload.selectedFee;
        state.loading = false;
        state.selectedQuantity = '1';
      }
      
    },
    //#endregion
    
    //#region ابعاد فریم
    setRXOrderSelectedHBOX: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.HBOX = payload;
      state.loading = false;
    },
    setRXOrderSelectedVBOX: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.VBOX = payload;
      state.loading = false;
    },
    setRXOrderSelectedDBL: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.DBL = payload;
      state.loading = false;
    },
    setRXOrderSelectedED: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.ED = payload;
      state.loading = false;
    },
    setRXOrderSelectedPANTO: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.PANTO = payload;
      state.loading = false;
    },
    setRXOrderSelectedFFA: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.FFA = payload;
      state.loading = false;
    },
    setRXOrderSelectedBVD: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.BVD = payload;
      state.loading = false;
    },
    setRXOrderSelectedBase: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedBase = payload;
      state.loading = false;
    },
    setRXOrderSelectedIPDR: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.IPDR = payload;
      state.loading = false;
    },
    setRXOrderSelectedIPDL: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.IPDL = payload;
      state.loading = false;
    },
    setRXOrderSelectedFITTINGR: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.FITTINGR = payload;
      state.loading = false;
    },
    setRXOrderSelectedFITTINGL: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.FITTINGL = payload;
      state.loading = false;
    },
    setRXOrderSelectedFrameType: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedFrameType = payload;
      state.loading = false;
    },
    //#endregion

    //#region   رنگ و خدمات
    setRXOrderExtraServices: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.ExtraServices = payload;
      state.loading = false;
    },
    setRXOrderSelectedColor: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedColor = payload;
      state.loading = false;
    },
    setRXOrderSelectedColoringType: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedColoringType = payload;
      state.loading = false;
    },
    setRXOrderSelectedColorRate: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.colorRate = payload;
      state.loading = false;
    },
    setRXOrderSelectedColorRateTop: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.colorRateTop = payload;
      state.loading = false;
    },
    setRXOrderSelectedColorRateBottom: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.colorRateBottom = payload;
      state.loading = false;
    },
    setRXOrderSelectedExtraServices: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedExtraServices = payload;
      state.loading = false;
    },
    setRXOrderSelectedOldLens: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.oldLens = payload;
      state.loading = false;
    },
    setRXOrderSelectedEmergencyLevel: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.emergencyLevel = payload;
    },  
    //#endregion
    setRXOrderSelectedQuantity: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedQuantity = payload;
      state.loading = false;
    },
    updateConsumerData : (state , { payload}) =>{

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Consumer = payload.Value;
             
      }

    },
    setRXPreviewItems: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.previewItems = payload;
      state.previewItemsDialog = true;
    },
    setRXPreviewItemsDialogClose: (state, { payload }) => {
      state.previewItems = [];
      state.previewItemsDialog = false;
    },
    setRXPreviewItemsDialogOpen: (state, { payload }) => {
      state.previewItems = [];
      state.previewItemsDialog = true;
    },
    setRightValue : (state, { payload }) => {
      state.isRightOn = payload ? true : false;
    },
    setLeftValue : (state, { payload }) => {
      state.isLeftOn = payload ? true : false;
    },
    setRXOrderDescription: (state, { payload }) => {
      state.description = payload;
    },
    setRXOrderDateMustDelivered: (state, { payload }) => {
      state.dateMustDelivered = payload;
    },
    clearRXOrderItems: (state) => {
      state.items = [];
      state.currentPageIndex = 0;
      state.selectedRXOrderId = null;
    },
    clearSelectedRXOrder: (state) => {
      state.selectedRXOrderId = null;
    },
    clearRXOrderFilters: (state) => {
      state.searchKey = '';
    },
    setRXOrderConsumer: (state, { payload }) => {
      state.consumer = payload;
    },
    setRXOrderStoreName: (state, { payload }) => {
      state.storeName = payload;
    },
    loadRXOrder : (state, { payload }) => {
    
      state.consumer = payload.Consumer;
      state.storeName = payload.StoreName;
      state.service = payload.Service;
      state.lensbrands =  payload.Brands;
      state.selectedLensBrandId =  payload.selectedLensBrandId;
      state.lensTypes =  payload.LensTypes;
      state.selectedLensTypeId =   payload.selectedLensTypeId;
      state.number = payload.Number;
      state.trackingCode = payload.trackingCode;
      state.lensDesignTypes =  payload.LensDesignTypes;
      state.selectedLensDesignTypeId =  payload.selectedLensDesignTypeId;
    
      state.lensIndexes =  payload.LensIndexes;
      state.selectedLensIndexId =  payload.selectedLensIndexId;
    
      state.lensMaterialTypes =  payload.LensMaterialTypes;
      state.selectedLensMaterialTypeId =  payload.selectedLensMaterialTypeId;
     
      state.products =  payload.Products;
     
      state.coatings =  payload.Coatings;
      state.selectedCoatingId =  payload.Coating;

      state.selectedCoatingName = payload.SelectedCoatingName;

      state.corridors =  [{ Value : "auto", Name :  "auto"},{ Value :  "14mm", Name :  "14mm"}, { Value :  "16mm", Name :  "16mm"}, { Value :  "18mm", Name :  "18mm"}];
      state.selectedCorridor =  payload.Corridor;
    
      state.description =  payload.Description;
      state.dateMustDelivered =  payload.selectedDateMustDelivered;
      console.log(state.dateMustDelivered);
      state.netPrice = payload.NetPrice;
      //چشم ها
      //چپ
      state.LSPHSign =  payload.SignSPHL;
      state.LSPH =  payload.SPHL !== null ? Math.abs(payload.SPHL) : null;
      state.LCYLSign =  payload.SignCYLL;
      state.LCYL =  payload.CYLL !== null ? Math.abs(payload.CYLL) : null;
      state.LAXIS =  payload.AxisL;
      state.LADD =  payload.ADDL;
      state.LDIA =  payload.DIAL;
      state.LDC =  payload.DCL;
      state.LPosition = payload.PositionL;
      state.LPrism =  payload.PrismL;
      state.LBaseOfPrism = payload.BaseOfPrismL;
      //راست
      state.RSPHSign =  payload.SignSPHR;
      state.RSPH =  payload.SPHR !== null ? Math.abs(payload.SPHR) : null;
      state.RCYLSign =   payload.SignCYLR;
      state.RCYL =  payload.CYLR !== null ? Math.abs(payload.CYLR) : null;
      state.RAXIS =  payload.AxisR;
      state.RADD = payload.ADDR;
      state.RDIA = payload.DIAR;
      state.RDC = payload.DCR;
      state.RPosition = payload.PositionR;
      state.RPrism = payload.PrismR;
      state.RBaseOfPrism = payload.BaseOfPrismR;
     
      //ابعاد فریم
      state.HBOX =  payload.HBOX;
      state.VBOX =  payload.VBOX;
      state.DBL =  payload.DBL;
      state.ED =  payload.EFFECTIVEDIAMETER;
      state.PANTO =  payload.Panto;
      state.FFA =  payload.Ffa;
      state.BVD =  payload.Vd;
      state.selectedBase =  payload.BASE;
      state.IPDR =  payload.IPDR;
      state.IPDL =  payload.IPDL;
      state.FITTINGL =  payload.FITTINGL;
      state.FITTINGR =  payload.FITTINGR;
      state.selectedFrameType =  payload.FrameType;
      state.selectedColor =  payload.Color;
      state.selectedColoringType =  payload.ColoringType;
      state.colorRate =  payload.ColorRatio;
      state.colorRateTop =  payload.ColorRatioTop;
      state.colorRateBottom =  payload.ColorRatioBottom;
     
      state.selectedExtraServices = [];
      console.log(state.ExtraServices);
      if(payload.selectedExtraServices !== null && payload.selectedExtraServices !== undefined && payload.selectedExtraServices !== ""){
        payload.selectedExtraServices.map(y => {
          console.log(y);
          state.ExtraServices.map(x => {
            console.log(x);
            if(x.Value === y.toString()){
              console.log("x = y");
              state.selectedExtraServices.push({id: x.Value.toString(), label: x.Name.toString()});
            }
          });
        });
      }
      state.oldLens =  payload.OldLens;
      
      state.selectedProductId =  payload.selectedProductId;
      state.selectedProductCode =  payload.selectedProductCode;
      state.selectedProductTitle =  payload.selectedProductTitle;

      state.selectedRXOrderId =  payload.OrderId;
      state.customerPortalUserId = payload.CustomerPortalUserId;
      state.customerPortalCreatorId = payload.CustomerPortalCreatorId;

      state.OrderHistory = payload.OrderHistory;
      state.selectedRXStateDescription = '';
      state.orderState = payload.State;
      state.emergencyLevel = payload.EmergencyLevel;
      state.payTypeId = payload.PayTypeID;
    },
    clearRXOrderData: (state) => {
      state.number = "";
      state.trackingCode = "";
      state.selectedRXOrderId = null;
      state.loading = false;
      state.boxMessage = '';
      state.boxType = 0;//1 Error , 2 Success, 3 Info
      state.currentPageIndex = 0;
      state.items = [];
      state.selectedRXOrder = {};
      state.hasMore = true;
      state.searchKey  = '';
      state.fetchPermission = true;
      state.selectedLensBrandId = 0;
      state.lensTypes = [];
      state.selectedLensTypeId = 0;
      state.lensMaterialTypes = [];
      state.selectedLensMaterialTypeId = 0;
      state.lensDesignTypes = [];
      state.selectedLensDesignTypeId = 0;
      state.lensIndexes = [];
      state.selectedLensIndexId = 0;
      state.products = [];
      state.selectedProductId = 0;
      state.selectedProductCode = '';
      state.selectedProductTitle = '';
      state.coatings = [];
      state.selectedCoatingId = null;
      state.selectedCoatingName = '';
      state.service = '';
      state.selectedFee = 0;
      state.isWaitingForLeft = false;
      state.isLeftOn = false;
      state.isRightOn = false;
      state.previewItems = [];
      state.previewItemsDialog = false;
      state.description = '';
      state.dateMustDelivered = '';
      state.netPrice = 0;
      state.Sphs= [];
      state.Cyls= [];
      state.ADDs= [];
      state.DIAs= [];
      state.Axiss = [];
      state.DCs= [];
      state.Positions= [{ Value: "to nasal" , Name: "to nasal"}, { Value: "to temple", Name: "to temple"}];
      state.Prisms= [];
      state.BaseOfPrisms= [{ Value : "UP", Name: "UP"}, { Value: "DOWN", Name:"DOWN"}, { Value: "IN", Name: "IN"}, { Value: "OUT", Name:"OUT"}, { Value: "IN/UP", Name: "IN/UP"}, { Value: "IN/DOWN", Name: "IN/DOWN"}, { Value:"OUT/UP", Name: "OUT/UP"}, { Value: "OUT/DOWN", Name: "OUT/DOWN"}];
      state.LSPHSign= "false";
      state.LSPH= null;
      state.LCYLSign= "false";
      state.LCYL= null;
      state.LAXIS= null;
      state.LADD= null;
      state.LDIA= null;
      state.LDC= null;
      state.LPosition= null;
      state.LPrism= null;
      state.LBaseOfPrism= null;
      state.RSPHSign= "false";
      state.RSPH= null;
      state.RCYLSign= "false";
      state.RCYL= null;
      state.RAXIS= null;
      state.RADD= null;
      state.RDIA= null;
      state.RDC= null;
      state.RPosition= null;
      state.RPrism= null;
      state.RBaseOfPrism= null;

      state.HBOX = null;
      state.VBOX = null;
      state.DBL = null;
      state.ED = null;
      state.PANTO = null;
      state.FFA = null;
      state.BVD = null;
      state.selectedBase = null;
      state.IPDR = null;
      state.IPDL = null;
      state.FITTINGL = null;
      state.FITTINGR = null;
      state.FrameType = null;
      
      state.selectedColor = null;
      state.selectedColoringType = null;
      state.colorRate = null;
      state.colorRateTop = null;
      state.colorRateBottom = null;
      state.selectedExtraServices = [];
      state.IPDR = null;
      state.IPDL = null;
      state.oldLens = null;
      state.selectedFrameType = null;
      state.customerPortalCreatorId = '';
      
      state.consumer = '';
      state.storeName = '';
      state.description = '';
      state.OrderHistory = [];
      state.selectedRXStateDescription = '';
      state.orderState = '';
      state.emergencyLevel = 1;
      state.payTypeId = 1;
    }
  },
});

// export the actions
export const { 
  setRXOrderLoading, setRXOrderLoadingFalse, setRXOrderResultBox, resetRXOrderResultBox, clearRXOrderData, setRXOrderSearchKey, clearRXOrderItems ,clearRXOrderFilters, setSelectedRXOrder , setSelectedRXOrderId, clearSelectedRXOrder, 
  setRXOrderLensBrands, setRXOrderSelectedLensBrand,
  setRXOrderLensTypes, setRXOrderSelectedLensType,
  setRXOrderLensIndexes, setRXOrderSelectedLensIndex,
  setRXOrderLensCyls, setRXOrderSelectedLensCyl,
  setRXOrderLensSphs, setRXOrderSelectedLensSph,
  setRXOrderProducts, setRXOrderSelectedProduct,setRXOrderDescription, setRXOrderDateMustDelivered,
  setRXOrderSelectedLensMaterialType,setRXOrderLensMaterialTypes,setRXOrderSelectedLensDesignType,setRXOrderLensDesignTypes,
  addOrUpdateItem , deleteItem, deleteAllItems, updateOpticianData,updateNeedToolsData, updateAxisData, updateConsumerData,
  setRXOrderSelectedQuantity,
  setRightValue, setLeftValue,
  initialRXOrder,updateRXOrderADDValues,
  setRXOrderSelectedRSPH,setRXOrderSelectedRCYL,setRXOrderSelectedRAxis,setRXOrderSelectedRAdd,setRXOrderSelectedRDia,setRXOrderSelectedRDC,setRXOrderSelectedRPosition,setRXOrderSelectedRPrism,setRXOrderSelectedRBaseOfPrism,setRXOrderSelectedRSPHSign,setRXOrderSelectedRCYLSign,toggleRXOrderLeftEyeAccordion,
  setRXOrderSelectedLSPH,setRXOrderSelectedLCYL,setRXOrderSelectedLAxis,setRXOrderSelectedLAdd,setRXOrderSelectedLDia,setRXOrderSelectedLDC,setRXOrderSelectedLPosition,setRXOrderSelectedLPrism,setRXOrderSelectedLBaseOfPrism,setRXOrderSelectedLSPHSign,setRXOrderSelectedLCYLSign,toggleRXOrderRightEyeAccordion,
  copyLeftItemsToRight, copyRightItemsToLeft,
  setRXOrderSelectedHBOX,setRXOrderSelectedVBOX,setRXOrderSelectedDBL,setRXOrderSelectedED,setRXOrderSelectedPANTO,setRXOrderSelectedFFA,setRXOrderSelectedBVD,setRXOrderSelectedBase,setRXOrderSelectedIPDR,setRXOrderSelectedIPDL,setRXOrderSelectedFITTINGR,setRXOrderSelectedFITTINGL,setRXOrderSelectedFrameType,
  setRXOrderMatrix , setRXPreviewItems, setRXPreviewItemsDialogClose, setRXPreviewItemsDialogOpen,
  setRXOrderCoatings, setRXOrderSelectedCoating,setRXOrderExtraServices,setRXOrderSelectedColor, setRXOrderSelectedColoringType,setRXOrderSelectedColorRate,setRXOrderSelectedColorRateTop, setRXOrderSelectedColorRateBottom,setRXOrderSelectedOldLens,
  setRXOrderSelectedCorridor , setRXOrderSelectedExtraServices,
  loadRXOrder , setRXOrderConsumer, setRXOrderStoreName,
  setCustomerPortalUserId,  clearCustomerPortalUserId, setRXOrderStateDescription,
  setRXOrderReadonly, setRXOrderWrite , setRXOrderSelectedEmergencyLevel, setRXOrderPayType, setPostRefId

} = rxOrderSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const rxtOrderItemsSelector = (state) => state.items;

// export the default reducer
export default rxOrderSlice.reducer;



// fetch Brands
export function fetchLensBrands(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getLensBrandsURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          dispatch(setRXOrderLensBrands(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};
// fetch LensTypes
export function fetchLensTypes(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getRXLensTypesURL()+'?brandId='+input.selectedLensBrandId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setRXOrderLensTypes(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};
// fetch DesignTypes
export function fetchLensDesignTypes(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getRXLensDesignTypesURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setRXOrderLensDesignTypes(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};

// fetch Lens Indexes
export function fetchLensIndexes(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getRXLensIndexesURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&designTypeId='+input.selectedLensDesignTypeId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setRXOrderLensIndexes(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};
// fetch Material Types
export function fetchLensMaterialTypes(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getRXLensMaterialTypesURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&designTypeId='+input.selectedLensDesignTypeId+'&lensIndexId='+input.selectedLensIndexId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setRXOrderLensMaterialTypes(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};

// fetch Products
export function fetchProducts(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getRXProductsURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&designTypeId='+input.selectedLensDesignTypeId+'&lensIndexId='+input.selectedLensIndexId+'&materialTypeId='+input.selectedLensMaterialTypeId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setRXOrderProducts(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};

// fetch Product
export function fetchProduct(input) {
  return async (dispatch) => {

      dispatch(setRXOrderLoading());
      await axios.post(getProductByCodeURL()+'?code='+input.code+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          if(response.data.Value !== null){
            dispatch(addOrUpdateItem({selectedRowId : 0 , selectedProductId : response.data.Value , selectedProductCode : response.data.Code, selectedProductTitle : response.data.Name , selectedQuantity : 1 , selectedFee : response.data.Fee , Consumer : response.data.Consumer, Optician : response.data.Optician, Axis : response.data.Axis, NeedTools : response.data.NeedTools,  addQuantityToCurrent : true , isFromBarcode : input.isFromBarcode , authUser : input.authUser}));
          }else{
            dispatch(setRXOrderResultBox({message : "خطا در بارگذاری محصول" , type : 1}));
          }
          //
          
          
 
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};


export function getRXOrderPreview(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setRXOrderLoading());
    var _dateMustDelivered = "";
    console.log(input.rxOrder.dateMustDelivered);
   
    if(input.rxOrder.dateMustDelivered === ""){
        var theDate = new Date();
        //var day = zeroPad(theDate.getDate() , 2);
        //var month = zeroPad(theDate.getMonth() , 2);
        //var year = theDate.getFullYear();
        _dateMustDelivered = theDate.toISOString();//moment.from(year + "/" + month + "/"+ day, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    }else{
      _dateMustDelivered = moment.from(input.rxOrder.dateMustDelivered, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    }    

       
    let order = {};
    order = {
      OrderId: input.rxOrder.selectedRXOrderId,
      Product : input.rxOrder.selectedProductId,
      Customer : 0,
      Consumer : input.rxOrder.consumer,
      DateMustDelivered : _dateMustDelivered,//new Date().toISOString(),//'2012-04-23T18:25:43.511Z',//'2012-04-23T18:25:43.511Z',//      today,
      OldLens : input.rxOrder.oldLens,
      StoreName : input.rxOrder.storeName,
      Description : input.rxOrder.description,
      
      SignSPHL :  input.rxOrder.LSPHSign ,
      SignSPHR :  input.rxOrder.RSPHSign ,
      SignCYLL :  input.rxOrder.LCYLSign ,
      SignCYLR :  input.rxOrder.RCYLSign ,
      SPHL :  input.rxOrder.LSPH ,
      SPHR :  input.rxOrder.RSPH ,
      CYLL :  input.rxOrder.LSPH !== null ? input.rxOrder.LCYL : null,
      CYLR :  input.rxOrder.RSPH !== null ? input.rxOrder.RCYL : null,
      DIAL :  input.rxOrder.LSPH !== null ? input.rxOrder.LDIA : null,
      DIAR :  input.rxOrder.RSPH !== null ? input.rxOrder.RDIA : null,
      DCL :  input.rxOrder.LSPH !== null ? (input.rxOrder.LDC !== null && input.rxOrder.LDC !== undefined ? input.rxOrder.LDC.toString().replace('mm','') : null) : null,
      DCR :  input.rxOrder.RSPH !== null ? (input.rxOrder.RDC !== null && input.rxOrder.RDC !== undefined ? input.rxOrder.RDC.toString().replace('mm','') : null) : null,
      PrismL :  input.rxOrder.LSPH !== null ? input.rxOrder.LPrism : null,
      PrismR :  input.rxOrder.RSPH !== null ? input.rxOrder.RPrism : null,
      BaseOfPrismL : input.rxOrder.LSPH !== null ? input.rxOrder.LBaseOfPrism : null ,
      BaseOfPrismR : input.rxOrder.RSPH !== null ? input.rxOrder.RBaseOfPrism : null ,
      PositionL : input.rxOrder.LSPH !== null ? input.rxOrder.LPosition : null ,
      PositionR : input.rxOrder.RSPH !== null ? input.rxOrder.RPosition : null ,
      Corridor :  input.rxOrder.selectedCorridor ,
      AxisR : input.rxOrder.RSPH !== null ? input.rxOrder.RAXIS : null ,
      AxisL : input.rxOrder.LSPH !== null ? input.rxOrder.LAXIS : null ,
      ADDR : input.rxOrder.RSPH !== null ? input.rxOrder.RADD : null ,
      ADDL : input.rxOrder.LSPH !== null ? input.rxOrder.LADD : null ,
      HBOX :  input.rxOrder.HBOX ,
      VBOX :  input.rxOrder.VBOX ,
      FITTINGR : input.rxOrder.FITTINGR ,
      FITTINGL : input.rxOrder.LSPH !== null ? input.rxOrder.FITTINGL : null ,
      DBL :  input.rxOrder.DBL ,    
      IPDR : input.rxOrder.RSPH !== null ? input.rxOrder.IPDR : null ,  
      IPDL : input.rxOrder.LSPH !== null ? input.rxOrder.IPDL : null ,
      EFFECTIVEDIAMETER : input.rxOrder.ED , 
      Panto :  input.rxOrder.PANTO , 
      Ffa :  input.rxOrder.FFA , 
      Vd :  input.rxOrder.BVD , 
      Color :  input.rxOrder.selectedColor , 
      ColorRatio :  input.rxOrder.colorRate , 
      ColorRatioTop :  input.rxOrder.colorRateTop , 
      ColorRatioBottom :  input.rxOrder.colorRateBottom , 
      ColoringType :  input.rxOrder.selectedColoringType , 
      Coating :  input.rxOrder.selectedCoatingId , 
      BASE :  input.rxOrder.selectedBase , 
      Service :  input.rxOrder.selectedExtraServices.map(function(a) {return a.id;}).toString() , 
      FrameType :  input.rxOrder.selectedFrameType ,
      FrameImage :  null ,
      CustomerPortalUserId : input.rxOrder.customerPortalUserId,
      CustomerPortalCreatorId : input.authUser.id,
      EmergencyLevel : input.rxOrder.emergencyLevel,
      PayTypeID : input.rxOrder.payTypeId

    }

    var data = JSON.stringify(order);

    //console.log("data");
    //console.log(data);

    var config = {
      method: 'post',
      url: `${getRXOrderPreviewURL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    console.log(data);
    await axios(config).then(function (response) {
       
        console.log("response.data");
        console.log(response.data);
        if(response.data.RXOrderItemPreviewDataModels.length > 0 ){
          dispatch(setRXPreviewItems(response.data.RXOrderItemPreviewDataModels));
        }else{
          dispatch(setRXOrderResultBox({message : "خطا در بارگذاری اقلام پیش نمایش" , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  
  };
}


export function submitRXOrder(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setRXOrderLoading());
    var _dateMustDelivered = "";
    console.log(input.rxOrder.dateMustDelivered);
   
    if(input.rxOrder.dateMustDelivered === ""){
      var theDate = new Date();
      //var day = zeroPad(theDate.getDate() , 2);
      //var month = zeroPad(theDate.getMonth() , 2);
      //var year = theDate.getFullYear();
      _dateMustDelivered = theDate.toISOString();//moment.from(year + "/" + month + "/"+ day, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
  }else{
    _dateMustDelivered = moment.from(input.rxOrder.dateMustDelivered, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
  }    

   
  let order = {};
  order = {
    OrderId: input.rxOrder.selectedRXOrderId ,
    Product : input.rxOrder.selectedProductId,
    Customer : 0,
    Consumer : input.rxOrder.consumer,
    DateMustDelivered : _dateMustDelivered,//new Date().toISOString(),//'2012-04-23T18:25:43.511Z',//'2012-04-23T18:25:43.511Z',//      today,
    OldLens : input.rxOrder.oldLens,
    StoreName : input.rxOrder.storeName,
    Description : input.rxOrder.description,
    SignSPHL :  input.rxOrder.LSPHSign ,
    SignSPHR :  input.rxOrder.RSPHSign ,
    SignCYLL :  input.rxOrder.LCYLSign ,
    SignCYLR :  input.rxOrder.RCYLSign ,
    SPHL :  input.rxOrder.LSPH ,
    SPHR :  input.rxOrder.RSPH ,
    CYLL :  input.rxOrder.LSPH !== null ? input.rxOrder.LCYL : null,
    CYLR :  input.rxOrder.RSPH !== null ? input.rxOrder.RCYL : null,
    DIAL :  input.rxOrder.LSPH !== null ? input.rxOrder.LDIA : null,
    DIAR :  input.rxOrder.RSPH !== null ? input.rxOrder.RDIA : null,
    DCL :  input.rxOrder.LSPH !== null ? (input.rxOrder.LDC !== null && input.rxOrder.LDC !== undefined ? input.rxOrder.LDC.toString().replace('mm','') : null) : null,
    DCR :  input.rxOrder.RSPH !== null ? (input.rxOrder.RDC !== null && input.rxOrder.RDC !== undefined ? input.rxOrder.RDC.toString().replace('mm','') : null) : null,
    PrismL :  input.rxOrder.LSPH !== null ? input.rxOrder.LPrism : null,
    PrismR :  input.rxOrder.RSPH !== null ? input.rxOrder.RPrism : null,
    BaseOfPrismL : input.rxOrder.LSPH !== null ? input.rxOrder.LBaseOfPrism : null ,
    BaseOfPrismR : input.rxOrder.RSPH !== null ? input.rxOrder.RBaseOfPrism : null ,
    PositionL : input.rxOrder.LSPH !== null ? input.rxOrder.LPosition : null ,
    PositionR : input.rxOrder.RSPH !== null ? input.rxOrder.RPosition : null ,
    Corridor :  input.rxOrder.selectedCorridor ,
    AxisR : input.rxOrder.RSPH !== null ? input.rxOrder.RAXIS : null ,
    AxisL : input.rxOrder.LSPH !== null ? input.rxOrder.LAXIS : null ,
    ADDR : input.rxOrder.RSPH !== null ? input.rxOrder.RADD : null ,
    ADDL : input.rxOrder.LSPH !== null ? input.rxOrder.LADD : null ,
    HBOX :  input.rxOrder.HBOX ,
    VBOX :  input.rxOrder.VBOX ,
    FITTINGR : input.rxOrder.FITTINGR ,
    FITTINGL : input.rxOrder.LSPH !== null ? input.rxOrder.FITTINGL : null ,
    DBL :  input.rxOrder.DBL ,    
    IPDR : input.rxOrder.RSPH !== null ? input.rxOrder.IPDR : null ,  
    IPDL : input.rxOrder.LSPH !== null ? input.rxOrder.IPDL : null ,
    EFFECTIVEDIAMETER : input.rxOrder.ED , 
    Panto :  input.rxOrder.PANTO , 
    Ffa :  input.rxOrder.FFA , 
    Vd :  input.rxOrder.BVD , 
    Color :  input.rxOrder.selectedColor , 
    ColorRatio :  input.rxOrder.colorRate , 
    ColorRatioTop :  input.rxOrder.colorRateTop , 
    ColorRatioBottom :  input.rxOrder.colorRateBottom , 
    ColoringType :  input.rxOrder.selectedColoringType , 
    Coating :  input.rxOrder.selectedCoatingId , 
    BASE :  input.rxOrder.selectedBase , 
    Service :  input.rxOrder.selectedExtraServices.map(function(a) {return a.id;}).toString() , 
    FrameType :  input.rxOrder.selectedFrameType ,
    FrameImage :  null ,
    CustomerPortalUserId : input.rxOrder.customerPortalUserId,
    CustomerPortalCreatorId : input.authUser.id,
    EmergencyLevel : input.rxOrder.emergencyLevel,
    PayTypeID : input.rxOrder.payTypeId
  }

    var data = JSON.stringify(order);
    //console.log(data);
    console.log(data);
    var config = {
      method: 'post',
      url: `${getSubmitRXOrderURL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    //console.log(data);
    await axios(config).then(function (response) {
       
        console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          console.log("Success");
          if(input.rxOrder.payTypeId === 2 && response.data.Value !== undefined && response.data.Value !== null && response.data.Value.length > 0){
            //Go to Online Payment
            dispatch(clearRXOrderData());
            

            localStorage.removeItem('oldPosRefId');
            localStorage.removeItem('oldOrderId');
            localStorage.removeItem('amount');
        
            dispatch(setRXOrderLoading());
        
            //dispatch(setStatisticsLoading());
        
           axios.post(getOrderPaymentURL()+'?type=0&orderId='+ response.data.ID + '&amount='+response.data.Value+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
              .then(response => {

                  console.log(response.data);
                  dispatch(setPostRefId(response.data));
                 
                  localStorage.setItem('oldPosRefId', response.data);
                  localStorage.setItem('oldOrderId', response.data.ID);
                  localStorage.setItem('amount', response.data.Value);
        
                  postRefId(response.data);
        
              }).catch(function (err) {
                console.log(err);
                dispatch(setRXOrderResultBox({message : err.message , type : 1}));
                //console.log(errors[err.response.data]);
                
                //dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));

              }).finally(()=> {
        
              });



          }else{
            dispatch(clearRXOrderData());
            dispatch(initialRXOrder());
            dispatch(setRXOrderResultBox({message : response.data.Message , type : 2}));
          }
         
        }else{
          dispatch(setRXOrderResultBox({message : response.data.Message , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  
  };
}

export function submitOrderPayment(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setRXOrderLoading());
   

        if(input.rxOrder.selectedRXOrderId > 0 && input.rxOrder.orderState === "در_انتظار_پرداخت"){

              //Go to Online Payment
              dispatch(clearRXOrderData());
              localStorage.removeItem('oldPosRefId');
              localStorage.removeItem('oldOrderId');
              localStorage.removeItem('amount');
          
              dispatch(setRXOrderLoading());
          
              //dispatch(setStatisticsLoading());
          
             axios.post(getOrderPaymentURL()+'?type=2&orderId='+ input.rxOrder.selectedSTOrderId + '&amount='+parseFloat(input.rxOrder.netPrice)+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
                .then(response => {
                    dispatch(setPostRefId(response.data));
                   
                    localStorage.setItem('oldPosRefId', response.data);
                    localStorage.setItem('oldOrderId', response.data.ID);
                    localStorage.setItem('amount', parseFloat(response.data.Value));
          
                    postRefId(response.data);
          
                }).catch(function (err) {
                  console.log(err);
                  dispatch(setRXOrderResultBox({message : err.message , type : 1}));
                  //console.log(errors[err.response.data]);
                  
                  //dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));

                }).finally(()=> {
          
                });


          }else{
            dispatch(clearRXOrderData());
            dispatch(setRXOrderResultBox({message : "سفارش قابل پرداخت نیست" , type : 2}));
          }
  };
}

// fetch Coatings
export function fetchCoatings(input) {
  return async (dispatch) => {

    console.log(input);
      dispatch(setRXOrderLoading());
      await axios.post(getRXCoatingURL()+'?brandId='+input.selectedLensBrandId+'&materialTypeTitle='+input.selectedLensMaterialTypeValue+'&designTypeTitle='+input.selectedDesignTypeValue+'&defaultCoatingId='+input.defaultCoatingId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          dispatch(setRXOrderCoatings(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};

// fetch Coatings
export function fetchExtraServices(input) {
  return async (dispatch) => {

    console.log(input);
      dispatch(setRXOrderLoading());
      await axios.post(getRXExtraServicesURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          dispatch(setRXOrderExtraServices(response.data));
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};


// fetch rxOrder
export function fetchRXOrder(input) {
  return async (dispatch) => {

     dispatch(setRXOrderLoading());
      await axios.post(getOrderURL()+'?orderId='+input.orderId+'&type=0&isDetails='+input.isDetails+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          if(response.data.OrderId > 0 ){
            console.log("Load Order");
            dispatch(loadRXOrder(response.data));

            if(input.isDetails === 1){
              dispatch(setRXOrderReadonly());
            }

            if(response.data.RXOrderItemPreviewDataModels.length > 0 ){
              dispatch(setRXPreviewItems(response.data.RXOrderItemPreviewDataModels));
              dispatch(setOrderLoadingFalse());
            }else{
              dispatch(setRXOrderResultBox({message : "خطا در بارگذاری اقلام پیش نمایش" , type : 1}));
            }

          }else{
            dispatch(setRXOrderResultBox({message : "خطا در بارگذاری سفارش" , type : 1}));
          }
          
      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  }
};


// Change RXOrder State
export function ChangeRXOrderState(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setRXOrderLoading());
  
   
  let OrdersToApprove = {};
  OrdersToApprove = {

    OrderIds : [input.rxOrder.selectedRXOrderId],
    DstStates: [input.newState ],//["در_صف_تولید"] ,
    Descrptions : ["-"]
  }

    var data = JSON.stringify(OrdersToApprove);
    //console.log(data);
    console.log(data);
    var config = {
      method: 'post',
      url: `${getChangeOrderStateRL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    //console.log(data);
    await axios(config).then(function (response) {
       
        //console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          console.log("Success");
          dispatch(clearRXOrderData());
          //dispatch(initialRXOrder());
          dispatch(setRXOrderResultBox({message : response.data.Message , type : 2}));
        }else{
          dispatch(setRXOrderResultBox({message : response.data.Message , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setRXOrderResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setRXOrderLoadingFalse());
      });
  
  };
}


export const postRefId = (refIdValue) => {
  var form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", "https://bpm.shaparak.ir/pgwchannel/startpay.mellat");
  form.setAttribute("target", "_self");
  var hiddenField = document.createElement("input");
  hiddenField.setAttribute("name", "RefId");
  hiddenField.setAttribute("value", refIdValue);
  form.appendChild(hiddenField);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}